// location saga
import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/locationSlice";

import { geolocationApis, locationApis } from "src/api/location";

import { common } from "src/types/index";
import { constants } from "src/constants/common";

// get states saga
const GetStatesListSaga = function* GetStatesListSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      geolocationApis.getStateList,
      payload
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getStatesListSuccess(response?.data || []));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getStatesListError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// verify otp saga
const GetCitiesSaga = function* GetCitiesSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      geolocationApis.getCityList,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getCitiesListSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getCitiesListError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// get address list saga
const GetAddressListSaga = function* GetAddressListSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      locationApis.getAddressList,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getAddressListSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getAddressListError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// add and update address saga
const AddAndUpdateAddressSaga = function* AddAndUpdateAddressSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      locationApis.updateAddress,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.updateAddressSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.updateAddressError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// delete address saga
const DeleteAddressSaga = function* DeleteAddressSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      locationApis.deleteAddress,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    let data = null;
    if (Number(response?.code) === 1) {
      data = {
        address_id: payload.address_id,
      };
    }
    yield put(actions.deleteAddressSuccess(data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.deleteAddressError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// pincode validation saga
const PincodeValidationSaga = function* PincodeValidationSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      locationApis.pincodeValidation,
      payload
    );
    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.pincodeValidationSuccess(response?.data));
    resolve(response);
  } catch (error) {
    yield put(
      actions.pincodeValidationError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

export default function* locationSaga() {
  yield all([
    takeEvery(actions.getStatesListRequest, GetStatesListSaga),
    takeEvery(actions.getCitiesListRequest, GetCitiesSaga),
    takeEvery(actions.getAddressListRequest, GetAddressListSaga),
    takeEvery(actions.updateAddressRequest, AddAndUpdateAddressSaga),
    takeEvery(actions.deleteAddressRequest, DeleteAddressSaga),
    takeEvery(actions.pincodeValidationRequest, PincodeValidationSaga),
  ]);
}
